import { render, staticRenderFns } from "./blameList.vue?vue&type=template&id=74c25ca1&scoped=true&"
import script from "./blameList.vue?vue&type=script&lang=js&"
export * from "./blameList.vue?vue&type=script&lang=js&"
import style0 from "./blameList.vue?vue&type=style&index=0&id=74c25ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c25ca1",
  null
  
)

export default component.exports